module.exports = __webpack_public_path__ + "static/media/12D.802da1db.jpg";